import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { topProductsCountSelector } from '../../../../redux/pages/pages.selectors';
import Home from './home';
const mapStateToProps = createStructuredSelector({
  topProductsCount: topProductsCountSelector
});
export default connect(mapStateToProps, null)(Home);